import { useState, useEffect } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL

const COLORES_NIVEL = {
  PRE: '#94A3B8', A1: '#22C55E', A2: '#3B82F6', B1: '#8B5CF6', B2: '#F59E0B', C1: '#EF4444', C2: '#1B3A8C'
}
const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']

function formatearFecha(fechaStr) {
  if (!fechaStr) return ''
  const [anio, mes, dia] = fechaStr.split('-').map(Number)
  if (!anio || !mes || !dia) return fechaStr
  return `${dia} de ${MESES[mes - 1]} de ${anio}`
}

function Tile({ ic, num, label }) {
  return (
    <div style={{ background: '#fff', border: '1px solid var(--gris-borde)', borderRadius: 14, padding: '18px 12px', textAlign: 'center' }}>
      <div style={{ fontSize: 24, marginBottom: 6 }}>{ic}</div>
      <div style={{ fontSize: 26, fontWeight: 800, color: 'var(--azul)' }}>{num}</div>
      <div style={{ fontSize: 12, color: 'var(--gris-texto)', marginTop: 2 }}>{label}</div>
    </div>
  )
}

/* Pagina de "Mi Progreso": resumen de todo lo que el estudiante ha
   avanzado en la plataforma — lecciones del curriculo, retos
   diarios, palabras guardadas del diccionario y clases grupales a
   las que ha asistido (con el tema de cada una). */
export default function Progreso({ usuario }) {
  const [cargando, setCargando] = useState(true)
  const [datos,    setDatos]    = useState(null)
  const [error,    setError]    = useState(null)

  useEffect(() => {
    if (!usuario?.id) { setCargando(false); return }
    setCargando(true)
    axios.get(`${API}/progreso/resumen/${usuario.id}`).then(res => {
      setDatos(res.data)
    }).catch(err => {
      console.error('Error cargando progreso:', err)
      setError('No pudimos cargar tu progreso. Intenta de nuevo.')
    }).finally(() => setCargando(false))
  }, [usuario])

  if (cargando) {
    return <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--gris-texto)' }}>Cargando tu progreso...</div>
  }
  if (error) {
    return <div style={{ background: '#FEE2E2', color: '#B91C1C', borderRadius: 10, padding: '10px 14px', fontSize: 13 }}>{error}</div>
  }

  const d = datos || {}
  const clases = d.clases_grupales || []

  return (
    <div style={{ animation: 'fadeIn .3s ease both', maxWidth: 960 }}>
      <div style={{ background: 'linear-gradient(135deg,var(--azul-oscuro),var(--azul))', borderRadius: 18, padding: '28px 30px', color: '#fff', marginBottom: 26 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <span style={{ fontSize: 40 }}>📊</span>
            <div>
              <h1 style={{ fontSize: 24, fontWeight: 800 }}>Mi Progreso</h1>
              <p style={{ fontSize: 14, opacity: .85, marginTop: 4 }}>
                Todo lo que has avanzado en EnglishBridge hasta ahora.
              </p>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 20 }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 22, fontWeight: 800 }}>⚡ {(d.xp_total || 0).toLocaleString()}</div>
              <div style={{ fontSize: 11, opacity: .8 }}>XP totales</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 22, fontWeight: 800 }}>🔥 {d.racha_dias || 0}</div>
              <div style={{ fontSize: 11, opacity: .8 }}>Días de racha</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 22, fontWeight: 800 }}>{d.nivel_actual || 'PRE'}</div>
              <div style={{ fontSize: 11, opacity: .8 }}>Nivel actual</div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12, marginBottom: 34 }}>
        <Tile ic="📚" num={d.lecciones_completadas || 0} label="Lecciones del currículo completadas" />
        <Tile ic="🏆" num={d.retos_completados || 0} label="Retos diarios completados" />
        <Tile ic="🧑‍🏫" num={d.clases_grupales_total || 0} label="Clases grupales asistidas" />
        <Tile ic="📖" num={d.palabras_guardadas || 0} label="Palabras guardadas en el diccionario" />
      </div>

      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 16 }}>🧑‍🏫 Clases grupales a las que has asistido</h2>

      {clases.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px 20px', color: 'var(--gris-texto)', background: '#fff', border: '1px solid var(--gris-borde)', borderRadius: 16 }}>
          <div style={{ fontSize: 36, marginBottom: 8 }}>🗓️</div>
          <p style={{ fontSize: 13 }}>Todavía no has asistido a ninguna clase grupal. Resérvala desde "Clases en vivo".</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {clases.map((c, i) => (
            <div key={i} style={{ background: '#fff', border: '1px solid var(--gris-borde)', borderRadius: 14, padding: '16px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                  {c.nivel && (
                    <span style={{ background: COLORES_NIVEL[c.nivel] || 'var(--azul)', color: '#fff', fontSize: 11, fontWeight: 800, padding: '3px 10px', borderRadius: 999 }}>
                      {c.nivel}
                    </span>
                  )}
                  <span style={{ fontSize: 15, fontWeight: 700, color: 'var(--azul-oscuro)' }}>{c.titulo}</span>
                </div>
                <p style={{ fontSize: 12.5, color: 'var(--gris-texto)' }}>
                  {formatearFecha(c.fecha)}{c.profesor ? ` · con ${c.profesor_ic ? c.profesor_ic + ' ' : ''}${c.profesor}` : ''}
                </p>
              </div>
              {c.grabacion_url && (
                <a href={c.grabacion_url} target="_blank" rel="noreferrer"
                  style={{ fontSize: 12.5, fontWeight: 700, color: 'var(--azul)' }}>
                  ▶ Ver grabación
                </a>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
